const ResendMailSVG = ({height, width}) => {
    return (
      <svg
        version="1.1"
        id="Layer_1"
        xmlns="http://www.w3.org/2000/svg"
        xmlnsXlink="http://www.w3.org/1999/xlink"
        x="0px"
        y="0px"
        width={width}
        height={height}
        viewBox="0 0 357 394"
        enableBackground="new 0 0 357 394"
        xmlSpace="preserve"
      >
        {/* <path
          fill="#f8fafc"
          opacity="0.000000"
          stroke="none"
          d="
          M203.000000,395.000000 
          C135.333344,395.000000 68.166687,395.000000 1.000027,395.000000 
          C1.000018,263.666687 1.000018,132.333405 1.000009,1.000080 
          C119.999939,1.000053 238.999878,1.000053 357.999878,1.000027 
          C357.999908,132.333252 357.999908,263.666504 357.999939,394.999878 
          C306.500000,395.000000 255.000000,395.000000 203.000000,395.000000 
          M235.989914,327.989349 
          C235.989914,327.989349 235.977875,327.923462 235.472015,328.017639 
          C235.309753,328.073242 235.147507,328.128845 234.259109,328.318054 
          C229.886734,329.901917 225.550797,331.596466 221.135712,333.050598 
          C201.432556,339.539734 181.435379,343.440735 160.358200,339.545227 
          C160.869614,338.686127 161.251587,337.782349 161.857513,337.068756 
          C166.139572,332.025787 165.835007,325.870850 161.038300,321.549347 
          C156.148819,317.144257 149.738968,317.122772 144.198730,321.335388 
          C137.693954,326.281433 131.168091,331.204163 124.539902,335.982391 
          C116.532669,341.754761 116.364624,347.979248 120.855347,354.309662 
          C126.115036,361.724121 131.400131,369.127197 136.915436,376.351044 
          C139.976532,380.360443 144.430054,382.933868 149.392517,381.616394 
          C153.956680,380.404663 158.258636,377.548950 158.404083,371.918457 
          C158.486710,368.718750 157.633774,365.494843 157.290634,362.940460 
          C166.030731,362.940460 174.476532,362.710632 182.905548,362.989075 
          C199.633881,363.541656 215.725403,360.739868 231.010513,353.991669 
          C242.212784,349.045990 253.537140,344.202057 264.175232,338.194000 
          C280.345612,329.061401 293.348358,315.970245 304.869537,301.581421 
          C313.713287,290.536438 320.897797,278.330688 326.337006,265.215973 
          C329.113678,258.520996 331.694366,251.719681 333.884613,244.814499 
          C335.638062,239.286301 337.399292,233.587769 337.861877,227.860229 
          C338.728699,217.126984 339.333466,206.283920 338.792114,195.549820 
          C338.217987,184.166046 337.192383,172.615921 334.561249,161.567719 
          C330.227051,143.368210 322.697388,126.267105 311.859741,110.874306 
          C308.808563,106.540695 304.742188,102.921867 300.893188,98.340622 
          C299.584808,98.200180 298.276459,98.059746 296.330322,98.037048 
          C295.902710,98.095932 295.475098,98.154808 294.267181,98.036682 
          C285.078400,99.064827 280.929443,108.559914 286.808441,116.247475 
          C295.748749,127.938095 302.524200,140.644028 307.803192,154.365982 
          C312.794037,167.339096 314.940857,180.793350 315.922028,194.444687 
          C316.939850,208.605820 315.439972,222.814407 311.626190,236.380005 
          C306.173645,255.774643 297.500946,273.814117 284.206024,289.323029 
          C281.588562,292.376373 279.358734,295.761993 277.005188,299.002747 
          C277.005188,299.002747 276.992340,298.948517 276.290985,299.022156 
          C274.841797,300.678986 273.392578,302.335815 272.002289,304.002319 
          C272.002289,304.002319 271.992645,303.943420 271.287567,304.012115 
          C268.175934,306.672058 265.064331,309.332031 262.004333,312.005981 
          C262.004333,312.005981 261.997650,311.952972 261.284515,311.986267 
          C258.836884,313.986328 256.389282,315.986420 254.007111,317.995972 
          C254.007111,317.995972 254.007904,317.929871 253.377029,318.019379 
          C252.895645,318.341125 252.414276,318.662872 251.996078,318.996521 
          C251.996078,318.996521 251.989120,318.932587 251.323135,318.984497 
          C250.526474,319.646698 249.729828,320.308868 248.995392,320.989410 
          C248.995392,320.989410 248.977753,320.926971 248.249802,321.006165 
          C245.467834,322.677338 242.685867,324.348511 239.557648,326.062378 
          C239.557648,326.062378 239.227631,326.175476 238.585373,326.041412 
          C238.327728,326.370880 238.070084,326.700348 237.422562,327.078491 
          C237.422562,327.078491 237.048859,327.199951 236.511276,327.113617 
          C236.315338,327.402802 236.119400,327.691956 235.989914,327.989349 
          M237.433258,77.036507 
          C237.268829,77.354759 237.104416,77.673004 237.000656,77.992416 
          C237.000656,77.992416 236.972076,77.938881 236.247833,78.014961 
          C231.062027,81.683739 229.298325,87.575058 231.828278,92.777626 
          C234.553314,98.381363 240.327606,100.381653 247.902405,97.985107 
          C255.952972,95.639282 264.158661,93.717125 272.014893,90.840508 
          C281.856598,87.236870 283.647858,80.740547 280.626770,72.900322 
          C277.730560,65.384247 276.186768,57.356869 273.804077,49.629593 
          C272.248260,44.583916 268.272003,41.404686 263.480133,40.172596 
          C258.924835,39.001331 254.190918,40.661247 251.962296,44.919983 
          C250.323654,48.051327 250.437607,52.099819 249.712692,56.055351 
          C246.536636,54.720123 242.885773,53.026257 239.123077,51.634865 
          C229.853821,48.207241 220.652786,44.763195 210.834457,42.818153 
          C202.528702,41.172760 194.180527,40.884129 185.903030,39.751587 
          C168.239563,37.334846 151.258881,40.455986 134.342072,44.486919 
          C127.944405,46.011356 121.827820,48.750973 115.624084,51.047375 
          C94.223267,58.969177 75.611671,71.400902 60.181427,87.987747 
          C51.257034,97.581093 43.494377,108.434349 36.367702,119.469002 
          C29.632771,129.897110 25.575211,141.704269 21.741356,153.631027 
          C18.097170,164.967728 15.503356,176.384445 15.183668,188.112900 
          C14.624011,208.645279 13.883366,229.330978 21.946793,248.950882 
          C26.294605,259.529999 30.109221,270.387726 35.274021,280.556152 
          C41.362286,292.542694 49.855450,302.901764 59.047302,312.862427 
          C68.518806,323.126129 79.252769,331.591400 90.810036,339.035156 
          C97.725372,343.489075 106.698349,341.701904 109.278458,331.232300 
          C110.315079,327.025909 107.635376,322.350983 101.522110,318.064423 
          C95.163406,313.605743 88.569847,309.349182 82.821274,304.178925 
          C67.610405,290.498291 55.819939,274.164612 48.702171,254.929565 
          C44.735321,244.209549 40.876450,233.150467 39.324230,221.918671 
          C37.715485,210.277878 38.823189,198.242050 38.979225,186.382111 
          C39.160282,172.620224 43.587204,159.668182 48.608337,147.224579 
          C53.894844,134.123322 61.026718,121.711494 70.983795,111.333954 
          C77.007179,105.056229 82.761620,98.348572 89.583473,93.053642 
          C97.585709,86.842537 106.206474,81.106667 115.308792,76.720894 
          C125.321960,71.896263 135.919815,67.428085 146.750229,65.373985 
          C160.228439,62.817692 174.205414,62.891235 188.698395,62.213497 
          C189.444336,62.470615 190.172211,62.818951 190.938995,62.970894 
          C199.655289,64.698120 208.461853,66.057617 217.071320,68.207993 
          C223.894714,69.912262 230.478409,72.576180 237.522049,74.929192 
          C237.522049,74.929192 237.888077,74.994431 237.962784,75.648987 
          C237.946259,76.086998 237.929733,76.525017 237.979980,76.982910 
          C237.979980,76.982910 237.982422,76.913277 237.433258,77.036507 
          M215.955368,269.987915 
          C223.875656,269.991943 231.796555,270.048279 239.715652,269.953430 
          C241.202927,269.935638 242.682968,269.314240 244.496414,269.012604 
          C244.496414,269.012604 244.797928,268.872162 245.697083,268.983521 
          C247.864029,268.641754 250.030975,268.299957 252.919510,267.932678 
          C254.868576,266.876343 257.061340,266.108887 258.720612,264.709015 
          C263.532959,260.649109 265.966766,255.468231 265.827087,248.591492 
          C265.884521,220.040604 265.948486,191.489700 265.959442,162.938797 
          C265.959686,162.266434 265.364410,161.593842 265.015594,160.093826 
          C265.081940,151.957687 256.633636,144.097107 247.433273,144.086227 
          C200.012360,144.030151 152.590607,143.924454 105.171127,144.191208 
          C96.947990,144.237473 90.033356,150.484528 88.254456,160.253891 
          C88.166328,160.908920 88.001335,161.563904 88.001122,162.218964 
          C87.991760,191.033661 87.984802,219.848404 88.044792,248.662979 
          C88.047195,249.815125 88.701408,250.965942 89.014397,252.911850 
          C89.364182,259.845764 93.904694,265.182220 102.170448,268.744568 
          C105.175507,268.786713 108.180573,268.828827 111.463539,269.004730 
          C111.463539,269.004730 111.762001,268.926971 112.198845,269.730835 
          C146.478180,269.763550 180.757507,269.796234 215.955368,269.987915 
          "
        /> */}
        <path
          fill="#4083F0"
          opacity="1.000000"
          stroke="none"
          d="
          M237.888077,74.994431 
          C237.888077,74.994431 237.522049,74.929192 237.213318,74.547577 
          C236.579758,73.799133 236.319916,73.217468 235.920670,73.096680 
          C223.644836,69.383018 211.410690,65.509201 199.032349,62.170994 
          C195.565308,61.236000 191.667313,61.899063 187.966995,61.829079 
          C174.205414,62.891235 160.228439,62.817692 146.750229,65.373985 
          C135.919815,67.428085 125.321960,71.896263 115.308792,76.720894 
          C106.206474,81.106667 97.585709,86.842537 89.583473,93.053642 
          C82.761620,98.348572 77.007179,105.056229 70.983795,111.333954 
          C61.026718,121.711494 53.894844,134.123322 48.608337,147.224579 
          C43.587204,159.668182 39.160282,172.620224 38.979225,186.382111 
          C38.823189,198.242050 37.715485,210.277878 39.324230,221.918671 
          C40.876450,233.150467 44.735321,244.209549 48.702171,254.929565 
          C55.819939,274.164612 67.610405,290.498291 82.821274,304.178925 
          C88.569847,309.349182 95.163406,313.605743 101.522110,318.064423 
          C107.635376,322.350983 110.315079,327.025909 109.278458,331.232300 
          C106.698349,341.701904 97.725372,343.489075 90.810036,339.035156 
          C79.252769,331.591400 68.518806,323.126129 59.047302,312.862427 
          C49.855450,302.901764 41.362286,292.542694 35.274021,280.556152 
          C30.109221,270.387726 26.294605,259.529999 21.946793,248.950882 
          C13.883366,229.330978 14.624011,208.645279 15.183668,188.112900 
          C15.503356,176.384445 18.097170,164.967728 21.741356,153.631027 
          C25.575211,141.704269 29.632771,129.897110 36.367702,119.469002 
          C43.494377,108.434349 51.257034,97.581093 60.181427,87.987747 
          C75.611671,71.400902 94.223267,58.969177 115.624084,51.047375 
          C121.827820,48.750973 127.944405,46.011356 134.342072,44.486919 
          C151.258881,40.455986 168.239563,37.334846 185.903030,39.751587 
          C194.180527,40.884129 202.528702,41.172760 210.834457,42.818153 
          C220.652786,44.763195 229.853821,48.207241 239.123077,51.634865 
          C242.885773,53.026257 246.536636,54.720123 249.712692,56.055351 
          C250.437607,52.099819 250.323654,48.051327 251.962296,44.919983 
          C254.190918,40.661247 258.924835,39.001331 263.480133,40.172596 
          C268.272003,41.404686 272.248260,44.583916 273.804077,49.629593 
          C276.186768,57.356869 277.730560,65.384247 280.626770,72.900322 
          C283.647858,80.740547 281.856598,87.236870 272.014893,90.840508 
          C264.158661,93.717125 255.952972,95.639282 247.199509,97.762047 
          C245.537933,97.370827 244.570541,97.020630 243.622055,97.065918 
          C239.454102,97.264938 236.107788,95.831779 234.236603,92.028809 
          C232.229416,87.949440 232.886368,84.087494 235.840805,80.573769 
          C236.429626,79.873497 236.605682,78.826172 236.972076,77.938881 
          C236.972076,77.938881 237.000656,77.992416 237.211212,77.886169 
          C237.608658,77.491035 237.795532,77.202156 237.982422,76.913277 
          C237.982422,76.913277 237.979980,76.982910 238.233841,76.942963 
          C238.785919,76.582138 239.084137,76.261253 239.382355,75.940369 
          C238.884262,75.625053 238.386169,75.309746 237.888077,74.994431 
          "
        />
        <path
          fill="#4083EF"
          opacity="1.000000"
          stroke="none"
          d="
          M265.073975,249.020523 
          C265.966766,255.468231 263.532959,260.649109 258.720612,264.709015 
          C257.061340,266.108887 254.868576,266.876343 252.129517,267.889099 
          C249.158981,268.187744 246.978455,268.529968 244.797928,268.872162 
          C244.797928,268.872162 244.496414,269.012604 243.855499,268.922058 
          C233.812912,268.895660 224.411255,268.959808 214.547913,268.930450 
          C179.978165,268.866943 145.870087,268.896973 111.762001,268.926971 
          C111.762001,268.926971 111.463539,269.004730 110.974228,268.698181 
          C107.588539,268.239044 104.692169,268.086426 101.795792,267.933838 
          C93.904694,265.182220 89.364182,259.845764 89.045303,252.036865 
          C89.072754,220.725479 89.069290,190.289093 89.065834,159.852692 
          C90.033356,150.484528 96.947990,144.237473 105.171127,144.191208 
          C152.590607,143.924454 200.012360,144.030151 247.433273,144.086227 
          C256.633636,144.097107 265.081940,151.957687 265.006958,160.980087 
          C265.023529,190.917740 265.048737,219.969131 265.073975,249.020523 
          M242.777679,252.578125 
          C242.498627,252.390656 242.219574,252.203186 241.999420,252.005493 
          C241.999420,252.005493 241.970261,252.057678 241.922699,251.357651 
          C232.083984,241.339340 222.250305,231.316040 212.381332,221.327606 
          C212.095200,221.038010 211.435455,221.117584 210.998932,221.000092 
          C210.998932,221.000092 210.975540,221.049850 210.928268,220.354492 
          C207.933777,217.578629 204.939285,214.802780 201.997559,212.001175 
          C201.997559,212.001175 201.974350,212.055115 201.927872,211.477982 
          C201.251129,211.349716 200.574371,211.221466 199.196060,211.013626 
          C194.178345,215.148621 189.154099,219.275757 184.145142,223.421326 
          C180.679855,226.289276 176.987137,227.469589 173.058258,224.484863 
          C168.266068,220.844254 163.665756,216.949631 158.842133,213.353073 
          C157.935760,212.677277 155.780853,212.248444 155.201675,212.784882 
          C150.095886,217.513855 145.210159,222.480896 140.271088,227.389313 
          C132.818954,234.795151 125.308510,242.144653 117.988907,249.679413 
          C116.586220,251.123367 115.950356,253.312241 115.661407,255.606140 
          C116.642395,255.732605 117.623329,255.969116 118.604385,255.969681 
          C158.312012,255.992294 198.019669,256.002167 237.727264,255.963181 
          C239.165268,255.961777 240.602783,255.452576 242.435211,255.047623 
          C242.435211,255.047623 242.848969,255.001648 243.442810,254.936874 
          C243.769043,254.624237 244.095291,254.311600 244.421539,253.998962 
          C243.933426,253.672119 243.445312,253.345291 243.000839,252.996368 
          C243.000839,252.996368 242.991196,253.044312 242.777679,252.578125 
          M101.947304,243.488205 
          C101.990372,243.677094 102.033447,243.865997 102.290756,244.703644 
          C102.756767,244.706390 103.432602,244.913803 103.658455,244.682281 
          C111.586891,236.554474 119.439285,228.352417 127.376381,220.233139 
          C133.192276,214.283768 139.111496,208.435379 145.123352,202.402817 
          C137.294479,196.112778 129.757278,190.100937 122.269890,184.027725 
          C116.138580,179.054504 110.066597,174.008133 103.621544,168.639206 
          C103.068344,168.774231 102.515152,168.909256 101.453346,169.686172 
          C101.302338,170.663330 101.020561,171.640366 101.019508,172.617676 
          C100.995659,194.782196 100.988716,216.946777 101.039528,239.111206 
          C101.042442,240.380127 101.564034,241.647888 101.947304,243.488205 
          M250.671982,169.319336 
          C237.343246,180.109726 224.014511,190.900116 210.316605,201.989349 
          C223.764740,215.377884 236.722824,228.294769 249.728195,241.163818 
          C250.219772,241.650253 251.169785,241.673355 252.506516,241.347656 
          C252.640289,241.045959 252.890350,240.744629 252.891251,240.442551 
          C252.959869,217.534485 253.025238,194.626343 252.975266,171.718445 
          C252.973831,171.073120 251.724823,170.430511 250.671982,169.319336 
          M237.083832,157.007187 
          C202.148193,156.991257 167.212555,156.965347 132.276962,156.995285 
          C130.852844,156.996506 129.429169,157.523804 127.189041,157.619934 
          C122.545082,157.340790 117.901131,157.061646 113.257172,156.782501 
          C113.892899,159.158951 114.791946,160.513657 115.998566,161.487137 
          C124.492111,168.339615 133.033325,175.133392 141.589554,181.907684 
          C152.283127,190.374207 163.117462,198.668579 173.637131,207.345093 
          C176.264877,209.512436 178.221725,209.768494 180.631912,207.784119 
          C186.969086,202.566544 193.181488,197.195221 199.578720,192.053268 
          C210.034149,183.649460 220.594177,175.375748 231.115540,167.054062 
          C234.855957,164.095627 238.612305,161.157318 242.361374,158.209824 
          C242.174973,157.837051 241.988571,157.464279 241.802155,157.091507 
          C240.540985,157.091507 239.279800,157.091507 237.083832,157.007187 
          "
        />
        <path
          fill="#3F83F2"
          opacity="1.000000"
          stroke="none"
          d="
          M295.047485,98.213699 
          C295.475098,98.154808 295.902710,98.095932 296.913025,98.237007 
          C298.710999,98.616371 299.926208,98.795784 301.141449,98.975197 
          C304.742188,102.921867 308.808563,106.540695 311.859741,110.874306 
          C322.697388,126.267105 330.227051,143.368210 334.561249,161.567719 
          C337.192383,172.615921 338.217987,184.166046 338.792114,195.549820 
          C339.333466,206.283920 338.728699,217.126984 337.861877,227.860229 
          C337.399292,233.587769 335.638062,239.286301 333.884613,244.814499 
          C331.694366,251.719681 329.113678,258.520996 326.337006,265.215973 
          C320.897797,278.330688 313.713287,290.536438 304.869537,301.581421 
          C293.348358,315.970245 280.345612,329.061401 264.175232,338.194000 
          C253.537140,344.202057 242.212784,349.045990 231.010513,353.991669 
          C215.725403,360.739868 199.633881,363.541656 182.905548,362.989075 
          C174.476532,362.710632 166.030731,362.940460 157.290634,362.940460 
          C157.633774,365.494843 158.486710,368.718750 158.404083,371.918457 
          C158.258636,377.548950 153.956680,380.404663 149.392517,381.616394 
          C144.430054,382.933868 139.976532,380.360443 136.915436,376.351044 
          C131.400131,369.127197 126.115036,361.724121 120.855347,354.309662 
          C116.364624,347.979248 116.532669,341.754761 124.539902,335.982391 
          C131.168091,331.204163 137.693954,326.281433 144.198730,321.335388 
          C149.738968,317.122772 156.148819,317.144257 161.038300,321.549347 
          C165.835007,325.870850 166.139572,332.025787 161.857513,337.068756 
          C161.251587,337.782349 160.869614,338.686127 160.358200,339.545227 
          C181.435379,343.440735 201.432556,339.539734 221.135712,333.050598 
          C225.550797,331.596466 229.886734,329.901917 234.752655,328.367310 
          C235.490082,328.252197 235.733978,328.087830 235.977875,327.923462 
          C235.977875,327.923462 235.989914,327.989349 236.174622,327.903503 
          C236.631973,327.659546 236.861816,327.453644 237.048859,327.199951 
          C237.048859,327.199951 237.422562,327.078491 237.889099,326.977722 
          C238.646301,326.643127 238.936966,326.409302 239.227631,326.175476 
          C239.227631,326.175476 239.557648,326.062378 240.114471,326.029846 
          C243.440125,324.307220 246.208939,322.617096 248.977753,320.926971 
          C248.977753,320.926971 248.995392,320.989410 249.319855,320.999329 
          C250.425934,320.317047 251.207535,319.624817 251.989120,318.932587 
          C251.989120,318.932587 251.996078,318.996521 252.273987,318.969482 
          C253.037216,318.604950 253.522568,318.267395 254.007904,317.929871 
          C254.007904,317.929871 254.007111,317.995972 254.343536,318.000610 
          C257.119202,315.987823 259.558411,313.970398 261.997650,311.952972 
          C261.997650,311.952972 262.004333,312.005981 262.347595,312.011169 
          C265.791473,309.325378 268.892059,306.634399 271.992645,303.943420 
          C271.992645,303.943420 272.002289,304.002319 272.321289,303.968567 
          C274.090973,302.272705 275.541656,300.610596 276.992340,298.948517 
          C276.992340,298.948517 277.005188,299.002747 277.325470,298.970947 
          C284.110199,291.233185 291.628082,284.175415 296.842896,275.700470 
          C312.904083,249.598358 320.858032,221.252197 318.098511,190.241150 
          C315.743744,163.777939 307.143036,139.774887 291.541962,118.269318 
          C284.795929,108.970131 285.520020,104.971275 295.047485,98.213699 
          "
        />
        <path
          fill="#648AC1"
          opacity="1.000000"
          stroke="none"
          d="
          M294.657349,98.125191 
          C285.520020,104.971275 284.795929,108.970131 291.541962,118.269318 
          C307.143036,139.774887 315.743744,163.777939 318.098511,190.241150 
          C320.858032,221.252197 312.904083,249.598358 296.842896,275.700470 
          C291.628082,284.175415 284.110199,291.233185 277.297913,298.966797 
          C279.358734,295.761993 281.588562,292.376373 284.206024,289.323029 
          C297.500946,273.814117 306.173645,255.774643 311.626190,236.380005 
          C315.439972,222.814407 316.939850,208.605820 315.922028,194.444687 
          C314.940857,180.793350 312.794037,167.339096 307.803192,154.365982 
          C302.524200,140.644028 295.748749,127.938095 286.808441,116.247475 
          C280.929443,108.559914 285.078400,99.064827 294.657349,98.125191 
          "
        />
        <path
          fill="#E0F9FF"
          opacity="1.000000"
          stroke="none"
          d="
          M111.980423,269.328918 
          C145.870087,268.896973 179.978165,268.866943 214.559052,269.131531 
          C215.031845,269.426147 215.036835,269.828949 215.036835,269.828918 
          C180.757507,269.796234 146.478180,269.763550 111.980423,269.328918 
          "
        />
        <path
          fill="#638AC5"
          opacity="1.000000"
          stroke="none"
          d="
          M188.332703,62.021286 
          C191.667313,61.899063 195.565308,61.236000 199.032349,62.170994 
          C211.410690,65.509201 223.644836,69.383018 235.920670,73.096680 
          C236.319916,73.217468 236.579758,73.799133 237.036560,74.489975 
          C230.478409,72.576180 223.894714,69.912262 217.071320,68.207993 
          C208.461853,66.057617 199.655289,64.698120 190.938995,62.970894 
          C190.172211,62.818951 189.444336,62.470615 188.332703,62.021286 
          "
        />
        <path
          fill="#BDD5F5"
          opacity="1.000000"
          stroke="none"
          d="
          M88.660141,160.053284 
          C89.069290,190.289093 89.072754,220.725479 89.064064,251.639618 
          C88.701408,250.965942 88.047195,249.815125 88.044792,248.662979 
          C87.984802,219.848404 87.991760,191.033661 88.001122,162.218964 
          C88.001335,161.563904 88.166328,160.908920 88.660141,160.053284 
          "
        />
        <path
          fill="#95C3FF"
          opacity="1.000000"
          stroke="none"
          d="
          M265.450531,248.806000 
          C265.048737,219.969131 265.023529,190.917740 265.022583,161.393860 
          C265.364410,161.593842 265.959686,162.266434 265.959442,162.938797 
          C265.948486,191.489700 265.884521,220.040604 265.450531,248.806000 
          "
        />
        <path
          fill="#638AC5"
          opacity="1.000000"
          stroke="none"
          d="
          M236.609955,77.976921 
          C236.605682,78.826172 236.429626,79.873497 235.840805,80.573769 
          C232.886368,84.087494 232.229416,87.949440 234.236603,92.028809 
          C236.107788,95.831779 239.454102,97.264938 243.622055,97.065918 
          C244.570541,97.020630 245.537933,97.370827 246.796982,97.803001 
          C240.327606,100.381653 234.553314,98.381363 231.828278,92.777626 
          C229.298325,87.575058 231.062027,81.683739 236.609955,77.976921 
          "
        /> 
        <path
          fill="#FFFFFF"
          opacity="1.000000"
          stroke="none"
          d="
          M215.496094,269.908447 
          C215.036835,269.828949 215.031845,269.426147 215.020721,269.225037 
          C224.411255,268.959808 233.812912,268.895660 243.690460,268.901428 
          C242.682968,269.314240 241.202927,269.935638 239.715652,269.953430 
          C231.796555,270.048279 223.875656,269.991943 215.496094,269.908447 
          "
        />
        <path
          fill="#648AC1"
          opacity="1.000000"
          stroke="none"
          d="
          M271.640106,303.977783 
          C268.892059,306.634399 265.791473,309.325378 262.321808,312.004181 
          C265.064331,309.332031 268.175934,306.672058 271.640106,303.977783 
          "
        />
        <path
          fill="#648AC1"
          opacity="1.000000"
          stroke="none"
          d="
          M248.613770,320.966553 
          C246.208939,322.617096 243.440125,324.307220 240.287598,326.008484 
          C242.685867,324.348511 245.467834,322.677338 248.613770,320.966553 
          "
        />
        <path
          fill="#648AC1"
          opacity="1.000000"
          stroke="none"
          d="
          M276.641663,298.985352 
          C275.541656,300.610596 274.090973,302.272705 272.291809,303.963684 
          C273.392578,302.335815 274.841797,300.678986 276.641663,298.985352 
          "
        />
        <path
          fill="#80ABEB"
          opacity="1.000000"
          stroke="none"
          d="
          M101.983124,268.339203 
          C104.692169,268.086426 107.588539,268.239044 110.835274,268.631317 
          C108.180573,268.828827 105.175507,268.786713 101.983124,268.339203 
          "
        />
        <path
          fill="#80ABEB"
          opacity="1.000000"
          stroke="none"
          d="
          M245.247498,268.927856 
          C246.978455,268.529968 249.158981,268.187744 251.768707,267.901855 
          C250.030975,268.299957 247.864029,268.641754 245.247498,268.927856 
          "
        />
        <path
          fill="#648AC1"
          opacity="1.000000"
          stroke="none"
          d="
          M301.017334,98.657913 
          C299.926208,98.795784 298.710999,98.616371 297.231934,98.178131 
          C298.276459,98.059746 299.584808,98.200180 301.017334,98.657913 
          "
        />
        <path
          fill="#648AC1"
          opacity="1.000000"
          stroke="none"
          d="
          M251.656128,318.958557 
          C251.207535,319.624817 250.425934,320.317047 249.288757,320.990173 
          C249.729828,320.308868 250.526474,319.646698 251.656128,318.958557 
          "
        />
        <path
          fill="#638AC5"
          opacity="1.000000"
          stroke="none"
          d="
          M237.925430,75.321709 
          C238.386169,75.309746 238.884262,75.625053 239.382355,75.940369 
          C239.084137,76.261253 238.785919,76.582138 238.200455,76.933022 
          C237.929733,76.525017 237.946259,76.086998 237.925430,75.321709 
          "
        />
        <path
          fill="#648AC1"
          opacity="1.000000"
          stroke="none"
          d="
          M253.692474,317.974609 
          C253.522568,318.267395 253.037216,318.604950 252.242386,318.963562 
          C252.414276,318.662872 252.895645,318.341125 253.692474,317.974609 
          "
        />
        <path
          fill="#648AC1"
          opacity="1.000000"
          stroke="none"
          d="
          M235.724945,327.970551 
          C235.733978,328.087830 235.490082,328.252197 235.115738,328.300507 
          C235.147507,328.128845 235.309753,328.073242 235.724945,327.970551 
          "
        />
        <path
          fill="#648AC1"
          opacity="1.000000"
          stroke="none"
          d="
          M236.780060,327.156799 
          C236.861816,327.453644 236.631973,327.659546 236.141388,327.899414 
          C236.119400,327.691956 236.315338,327.402802 236.780060,327.156799 
          "
        />
        <path
          fill="#648AC1"
          opacity="1.000000"
          stroke="none"
          d="
          M238.906494,326.108459 
          C238.936966,326.409302 238.646301,326.643127 238.084030,326.953400 
          C238.070084,326.700348 238.327728,326.370880 238.906494,326.108459 
          "
        />
        <path
          fill="#638AC5"
          opacity="1.000000"
          stroke="none"
          d="
          M237.707840,76.974892 
          C237.795532,77.202156 237.608658,77.491035 237.180878,77.885590 
          C237.104416,77.673004 237.268829,77.354759 237.707840,76.974892 
          "
        />
        {/* <path
          fill="#f8fafc"
          opacity="0.000000"
          stroke="none"
          d="
          M242.848969,255.001648 
          C242.848969,255.001648 242.435211,255.047623 241.769180,255.038574 
          C226.476868,255.018845 211.850571,254.983963 197.224319,255.002731 
          C169.803101,255.037918 142.381927,255.104126 114.960724,255.157455 
          C115.950356,253.312241 116.586220,251.123367 117.988907,249.679413 
          C125.308510,242.144653 132.818954,234.795151 140.271088,227.389313 
          C145.210159,222.480896 150.095886,217.513855 155.201675,212.784882 
          C155.780853,212.248444 157.935760,212.677277 158.842133,213.353073 
          C163.665756,216.949631 168.266068,220.844254 173.058258,224.484863 
          C176.987137,227.469589 180.679855,226.289276 184.145142,223.421326 
          C189.154099,219.275757 194.178345,215.148621 199.679474,211.341309 
          C200.766693,211.797699 201.370529,211.926407 201.974350,212.055115 
          C201.974350,212.055115 201.997559,212.001175 202.004028,212.364471 
          C204.998856,215.501801 207.987198,218.275818 210.975540,221.049850 
          C210.975540,221.049850 210.998932,221.000092 211.004135,221.363403 
          C218.092087,229.045593 225.096603,236.442642 232.294891,243.646057 
          C235.308243,246.661545 238.732697,249.266235 241.970261,252.057678 
          C241.970261,252.057678 241.999420,252.005493 242.042175,252.270523 
          C242.387024,252.705139 242.689102,252.874725 242.991196,253.044312 
          C242.991196,253.044312 243.000839,252.996368 242.994568,253.339447 
          C242.941864,254.122238 242.895432,254.561951 242.848969,255.001648 
          "
        /> */}
        {/* <path
          fill="#f8fafc"
          opacity="0.000000"
          stroke="none"
          d="
          M238.018631,157.091492 
          C239.279800,157.091507 240.540985,157.091507 241.802155,157.091507 
          C241.988571,157.464279 242.174973,157.837051 242.361374,158.209824 
          C238.612305,161.157318 234.855957,164.095627 231.115540,167.054062 
          C220.594177,175.375748 210.034149,183.649460 199.578720,192.053268 
          C193.181488,197.195221 186.969086,202.566544 180.631912,207.784119 
          C178.221725,209.768494 176.264877,209.512436 173.637131,207.345093 
          C163.117462,198.668579 152.283127,190.374207 141.589554,181.907684 
          C133.033325,175.133392 124.492111,168.339615 115.998566,161.487137 
          C114.791946,160.513657 113.892899,159.158951 113.257172,156.782501 
          C117.901131,157.061646 122.545082,157.340790 128.062012,157.795425 
          C163.957260,157.980072 198.979538,157.999268 234.001740,157.960052 
          C235.341019,157.958557 236.679688,157.393784 238.018631,157.091492 
          "
        /> */}
        {/* <path
          fill="#f8fafc"
          opacity="0.000000"
          stroke="none"
          d="
          M103.968307,168.994202 
          C110.066597,174.008133 116.138580,179.054504 122.269890,184.027725 
          C129.757278,190.100937 137.294479,196.112778 145.123352,202.402817 
          C139.111496,208.435379 133.192276,214.283768 127.376381,220.233139 
          C119.439285,228.352417 111.586891,236.554474 103.658455,244.682281 
          C103.432602,244.913803 102.756767,244.706390 102.568604,244.172852 
          C102.898605,220.245529 102.933350,196.848923 103.043854,173.452682 
          C103.050888,171.965088 103.646507,170.480301 103.968307,168.994202 
          "
        /> */}
        {/* <path
          fill="#f8fafc"
          opacity="0.000000"
          stroke="none"
          d="
          M251.906158,241.912384 
          C251.169785,241.673355 250.219772,241.650253 249.728195,241.163818 
          C236.722824,228.294769 223.764740,215.377884 210.316605,201.989349 
          C224.014511,190.900116 237.343246,180.109726 250.842865,169.972778 
          C251.045166,171.454422 251.076584,172.282623 251.047684,173.567627 
          C251.039139,194.988113 251.090912,215.951767 251.093079,237.287415 
          C251.331039,239.077057 251.618607,240.494736 251.906158,241.912384 
          "
        /> */}
        <path
          fill="#5A88CC"
          opacity="1.000000"
          stroke="none"
          d="
          M115.311066,255.381805 
          C142.381927,255.104126 169.803101,255.037918 197.224319,255.002731 
          C211.850571,254.983963 226.476868,255.018845 241.571838,255.104767 
          C240.602783,255.452576 239.165268,255.961777 237.727264,255.963181 
          C198.019669,256.002167 158.312012,255.992294 118.604385,255.969681 
          C117.623329,255.969116 116.642395,255.732605 115.311066,255.381805 
          "
        />
        <path
          fill="#AFCEF9"
          opacity="1.000000"
          stroke="none"
          d="
          M237.551239,157.049347 
          C236.679688,157.393784 235.341019,157.958557 234.001740,157.960052 
          C198.979538,157.999268 163.957260,157.980072 128.470154,157.888458 
          C129.429169,157.523804 130.852844,156.996506 132.276962,156.995285 
          C167.212555,156.965347 202.148193,156.991257 237.551239,157.049347 
          "
        />
        <path
          fill="#5A88CC"
          opacity="1.000000"
          stroke="none"
          d="
          M241.946472,251.707672 
          C238.732697,249.266235 235.308243,246.661545 232.294891,243.646057 
          C225.096603,236.442642 218.092087,229.045593 210.979614,221.375885 
          C211.435455,221.117584 212.095200,221.038010 212.381332,221.327606 
          C222.250305,231.316040 232.083984,241.339340 241.946472,251.707672 
          "
        />
        <path
          fill="#5A7FAD"
          opacity="1.000000"
          stroke="none"
          d="
          M251.108002,173.110809 
          C251.076584,172.282623 251.045166,171.454422 251.035645,170.206436 
          C251.724823,170.430511 252.973831,171.073120 252.975266,171.718445 
          C253.025238,194.626343 252.959869,217.534485 252.891251,240.442551 
          C252.890350,240.744629 252.640289,241.045959 252.206329,241.630035 
          C251.618607,240.494736 251.331039,239.077057 251.388580,236.998825 
          C251.817535,215.809326 251.908249,195.280396 251.948257,174.751373 
          C251.949326,174.205063 251.400436,173.657684 251.108002,173.110809 
          "
        />
        <path
          fill="#95C2FF"
          opacity="1.000000"
          stroke="none"
          d="
          M103.794922,168.816711 
          C103.646507,170.480301 103.050888,171.965088 103.043854,173.452682 
          C102.933350,196.848923 102.898605,220.245529 102.461487,243.848465 
          C102.033447,243.865997 101.990372,243.677094 101.954697,242.745270 
          C101.962044,217.682999 101.961998,193.363632 101.961960,169.044281 
          C102.515152,168.909256 103.068344,168.774231 103.794922,168.816711 
          "
        />
        <path
          fill="#4681DE"
          opacity="1.000000"
          stroke="none"
          d="
          M101.707657,169.365234 
          C101.961998,193.363632 101.962044,217.682999 101.903152,242.459259 
          C101.564034,241.647888 101.042442,240.380127 101.039528,239.111206 
          C100.988716,216.946777 100.995659,194.782196 101.019508,172.617676 
          C101.020561,171.640366 101.302338,170.663330 101.707657,169.365234 
          "
        />
        <path
          fill="#5A88CC"
          opacity="1.000000"
          stroke="none"
          d="
          M210.951904,220.702179 
          C207.987198,218.275818 204.998856,215.501801 201.977646,212.377350 
          C204.939285,214.802780 207.933777,217.578629 210.951904,220.702179 
          "
        />
        <path
          fill="#5A88CC"
          opacity="1.000000"
          stroke="none"
          d="
          M243.145905,254.969269 
          C242.895432,254.561951 242.941864,254.122238 242.972748,253.350494 
          C243.445312,253.345291 243.933426,253.672119 244.421539,253.998962 
          C244.095291,254.311600 243.769043,254.624237 243.145905,254.969269 
          "
        />
        <path
          fill="#5A88CC"
          opacity="1.000000"
          stroke="none"
          d="
          M201.951111,211.766541 
          C201.370529,211.926407 200.766693,211.797699 200.030243,211.381104 
          C200.574371,211.221466 201.251129,211.349716 201.951111,211.766541 
          "
        />
        <path
          fill="#5A88CC"
          opacity="1.000000"
          stroke="none"
          d="
          M242.884430,252.811218 
          C242.689102,252.874725 242.387024,252.705139 242.012726,252.275635 
          C242.219574,252.203186 242.498627,252.390656 242.884430,252.811218 
          "
        />
        <path
          fill="#BDC7FF"
          opacity="1.000000"
          stroke="none"
          d="
          M251.047699,173.567627 
          C251.400436,173.657684 251.949326,174.205063 251.948257,174.751373 
          C251.908249,195.280396 251.817535,215.809326 251.438171,236.626846 
          C251.090912,215.951767 251.039139,194.988113 251.047699,173.567627 
          "
        />
      </svg>
    );
  };

  export default ResendMailSVG;